<template>

  <div class="poll-page">

    <section class="poll-content">

    <q-breadcrumbs
      active-color="blue-10"
      separator-color="blue-10"
      class="text-blue-grey-10 q-pa-md"
    >
      <q-breadcrumbs-el class="cursor-pointer" label="Главная" icon="home" @click="goToMain" />
      <q-breadcrumbs-el label="Анкетирование" icon="ballot" />
    </q-breadcrumbs>

      <!-- MOBILE -->
      <q-stepper
        v-if="isMobile"
        v-model="step"
        vertical
        animated
        header-nav
        color="accent"
        active-color="blue-grey-8"
        done-color="light-green-6"
        keep-alive
      >

        <q-step
          v-for="chapter in poll"
          :key="chapter.chapter_number"
          :name="chapter.chapter_number"
          :title="chapter.chapter"
          :caption="chapter.description"
          icon="ballot"
          :done="step > chapter.chapter_number"
        >

          <q-list>

            <q-item
              v-for="question in chapter.questions"
              :key="question.number"
            >

              <Suspense>

              <component
                :is="defineFieldType(question.type)"
                :context="question"
                @hoistAnswer="captureAnswer"
              />

              <template #fallback>
                <AppLoader />
              </template>

              </Suspense>

            </q-item>

          </q-list>

          <q-stepper-navigation>

            <q-btn
              v-if="chapter.chapter_number > 1"
              flat
              color="primary"
              icon="arrow_back"
              label="Назад"
              @click="prevStep(chapter)"
            />

            <q-btn
              v-if="chapter.chapter_number < poll.length"
              color="accent"
              icon="arrow_forward"
              label="Далее"
              @click="nextStep(chapter)"
            />

            <q-btn
              v-if="chapter.chapter_number === poll.length"
              color="accent"
              icon="done"
              label="Завершить"
              @click="finishPoll(chapter)"
            />

          </q-stepper-navigation>

        </q-step>

      </q-stepper>

      <!-- DESKTOP -->
      <div v-else class="poll-layout">

        <aside class="poll-sidebar">

          <div
            v-for="chapter in poll"
            :key="chapter.chapter_number"
            class="chapter-item"
            :class="{ active: step === chapter.chapter_number }"
            @click="step = chapter.chapter_number"
          >

            <div class="chapter-number">
              {{ chapter.chapter_number }}
            </div>

            <div>

              <div class="chapter-title">
                {{ chapter.chapter }}
              </div>

              <div class="chapter-subtitle">
                {{ chapter.description }}
              </div>

            </div>

          </div>

        </aside>

        <main class="poll-main">

          <div
            v-for="chapter in poll"
            :key="chapter.chapter_number"
            v-show="chapter.chapter_number === step"
          >

            <div class="chapter-header">
              {{ chapter.chapter }}
            </div>

            <div class="question-list">

              <div
                v-for="question in chapter.questions"
                :key="question.number"
                class="question-card"
              >

                <Suspense>

                <component
                  :is="defineFieldType(question.type)"
                  :context="question"
                  @hoistAnswer="captureAnswer"
                />

                <template #fallback>
                  <AppLoader />
                </template>

                </Suspense>

              </div>

            </div>

            <div class="poll-nav">

              <q-btn
                v-if="chapter.chapter_number > 1"
                flat
                icon="arrow_back"
                color="primary"
                label="Назад"
                @click="prevStep(chapter)"
              />

              <q-btn
                v-if="chapter.chapter_number < poll.length"
                color="accent"
                icon="arrow_forward"
                label="Далее"
                @click="nextStep(chapter)"
              />

              <q-btn
                v-if="chapter.chapter_number === poll.length"
                color="accent"
                icon="done"
                label="Завершить"
                @click="finishPoll(chapter)"
              />

            </div>

          </div>

        </main>

      </div>

    </section>

  </div>

</template>

<script lang="ts">
import {
  ref,
  computed,
  defineAsyncComponent,
  onMounted,
} from 'vue';
import { storeToRefs } from 'pinia';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store';
import AppLoader from '@/components/AppLoader.vue';

export default { name: 'PollPage' };
</script>

<script setup lang="ts">
const ecoStore = useEcoHospitalStore();
const { poll } = storeToRefs(ecoStore);

onMounted(async () => {
  await ecoStore.getPoll();
});

const step = ref(1);
const done = ref(false);
const isMobile = computed(() => window.innerWidth < 900);

const defineFieldType = computed(() => (type: string) => defineAsyncComponent(() => import(`~components/fields/${type}Field.vue`)));

const captureAnswer = (context:any) => {
  const qI = poll.value[step.value - 1].questions
    .findIndex((i) => i.number === context.number);

  if (qI > -1) poll.value[step.value - 1].questions[qI].answers = context.answers;
};

const prevStep = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  step.value -= 1;
};

const nextStep = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  step.value += 1;
};

const finishPoll = async (chapter:any) => {
  await ecoStore.sendChaptersAnswers({
    page: step.value,
    chapter,
  });

  done.value = true;

  useMainStore().showMessage('Спасибо за ответы');
};
// function resetPoll() {
//   done.value = false;
//   step.value = 1;
// }

const goToMain = () => {
  router.push({
    name: 'HealthPageFull',
  });
};

</script>

<style>
.poll-page {

  min-height: 100%;

  background: linear-gradient(
    180deg,
    #0b2d6b 0%,
    #144aa0 25%,
    #f6f7fb 65%,
    #f6f7fb 100%
  );

}

.poll-hero {

  padding: 24px 20px 26px;

}

.poll-hero-inner {

  max-width: 1150px;
  margin: 0 auto;

}

.poll-title {

  font-size: 22px;
  font-weight: 700;
  color: white;

}

.poll-subtitle {

  font-size: 14px;
  color: rgba(255,255,255,0.75);
  margin-top: 4px;

}

.poll-content {

  padding: 18px 20px 40px;

  max-width: 1150px;
  margin: 0 auto;

  background: white;

  border-radius: 26px;

  box-shadow: 0 -8px 30px rgba(0,0,0,0.08);

}

.poll-layout {

  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 32px;

}

.poll-sidebar {

  position: sticky;
  top: 70px;
  height: fit-content;

}

.chapter-item {

  display: flex;
  gap: 12px;

  padding: 12px;

  border-radius: 14px;

  border: 1px solid #eef0f6;

  cursor: pointer;

  transition: .15s;

  margin-bottom: 1rem;

}

.chapter-item:hover {

  background: #f6f8ff;

}

.chapter-item.active {

  border-color: #2563eb;
  background: #eef4ff;

}

.chapter-number {

  padding-left: 10px;
  padding-right: 10px;
  height: 30px;

  border-radius: 8px;

  background: #eef4ff;

  color: #2563eb;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 600;

}

.chapter-title {

  font-size: 14px;
  font-weight: 600;

}

.chapter-subtitle {

  font-size: 12px;
  color: #6b7280;

}

.poll-main {

  display: flex;
  flex-direction: column;

}

.chapter-header {

  font-size: 18px;
  font-weight: 700;

  margin-bottom: 16px;

}

.question-list {

  display: flex;
  flex-direction: column;
  gap: 14px;

}

.question-card {

  background: white;

  border: 1px solid #eef0f6;

  border-radius: 16px;

  padding: 16px;

}

.poll-nav {

  display: flex;

  justify-content: space-between;

  margin-top: 26px;

}

.finish-card {

  border-radius: 18px;
  border: 1px solid #eef0f6;

}

.finish-title {

  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;

}

.finish-btn {

  height: 46px;
  border-radius: 10px;

}

.poll-field {

  display: flex;
  flex-direction: column;
  gap: 10px;

}

.poll-question {

  display: flex;
  align-items: flex-start;

  font-size: 15px;
  font-weight: 500;

  color: #111827;

}

.poll-number {

  background: #eef4ff;
  color: #2563eb;

  font-weight: 600;

}

.poll-question-text {

  line-height: 1.4;

}

.poll-options {

  display: flex;
  flex-direction: column;
  gap: 8px;

  margin-left: 34px;

}

.poll-input {

  max-width: 420px;

}

.question-number {
  min-width: 28px;
  height: 28px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  background: #eef4ff !important;
  color: #2563eb !important;

  font-size: 13px;
  font-weight: 700;

  padding: 0;

  flex-shrink: 0;
}

.q-checkbox__label,
.q-radio__label {

  font-size: 14px;
  color: #374151;

}

.q-field--outlined .q-field__control {

  border-radius: 12px;
  background: #fafbff;
  border: 1px solid #e6e8ef;

}

.q-field--focused .q-field__control {

  border-color: #2563eb;

}

.poll-note {

  font-size: 12px;
  color: #6b7280;

  margin-left: 34px;

}

.q-checkbox,
.q-radio {

  padding: 6px 4px;
  border-radius: 8px;

}

.q-checkbox:hover,
.q-radio:hover {

  background: #f5f7ff;

}

@media (max-width: 900px) {

  .poll-layout {

    grid-template-columns: 1fr;

  }

  .poll-sidebar {

    flex-direction: row;
    overflow-x: auto;

  }

  .chapter-item {

    min-width: 180px;

  }

}

@media (max-width: 600px) {

  .poll-content {

    border-radius: 20px;

  }

}
</style>
